<template>
  <div>
    <template v-if="!isLoading && !sites.length">
      <add-first-site />
    </template>

    <c-row v-show="isLoading">
      <c-col sm="12">
        <p class="lead">
          Getting sites...
          <c-spinner color="success" size="sm" />
        </p>
      </c-col>
    </c-row>

    <template v-if="!isLoading && sites.length">
      <c-row>
        <c-col sm="12">
          <c-tabs>
            <c-tab title="Sites" active>
              <template slot="title">
                <c-icon :content="freeSet.cilBrowser" />
                Sites
                <pill :value="numberOfSites" />
              </template>
              <site-list
                md="3"
                lg="2"
                :sites="getSitesOrdered()"
                :hide-header="true"
                :show-only-require-updates="true"
                :view-type-default="'grid'"
              ></site-list>
            </c-tab>
            <!--            <CTab title="All Sites">-->
            <!--              <template slot="title">-->
            <!--                <CIcon :content="freeSet.cilBrowser"/> All Sites <pill :value="numberOfSites"/>-->
            <!--              </template>-->
            <!--              <site-list md="3" lg="2" :sites="getSitesOrdered()" :hideHeader="true" :showOnlyRequireUpdates="false" :viewTypeDefault="'grid'"></site-list>-->
            <!--            </CTab>-->
          </c-tabs>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import { buildEndpoint } from '../../libs/buildEndPoint';
import SiteList from '../components/site-list-v2';
import Plugins from '../components/dashboard/plugins';
import Pill from '../components/Pill';
import AddFirstSite from '@/views/components/dashboard/AddFirstSite';

export default {
  name: 'Sites',

  components: {
    SiteList,
    Plugins,
    Pill,
    AddFirstSite,
  },

  data() {
    return {
      freeSet,
      sites: [],
      isLoading: true,
      isScraping: false,
      status: false,
      error: null,
      numberOfSites: 0,
      uniquePluginCount: 0,
      numberOfSitesRequiringUpdates: 0,
      mostPopularPlugin: false,
      visible: true,
      pluginSummary: null,
      fullName: '',
      showUpdateAllSites: false,
      updateAllSitesRequestQueued: false,
      sitesViewType: 'grid',
    };
  },

  created() {
    this.fullName = `${this.$store.state.app.authenticatedUser.firstName} ${this.$store.state.app.authenticatedUser.lastName}`;
    this.fetchData();
  },

  computed: mapGetters({
    notificationSidebar: 'notificationSidebar',
    siteUpdates: 'siteUpdates',
    allowBetaFeatures: 'allowBetaFeatures',
  }),

  methods: {
    ...mapActions(['toggleNotifications', 'queueSiteUpdate']),
    getSitesOrdered() {
      return _.orderBy(this.sites, ['updatesRequired'], ['desc']);
    },
    fetchData() {
      this.isLoading = true;
      this.status = 'Getting data...';
      const _this = this;
      _this.sites = [];
      _this.pluginSummary = [];
      _this.updatesRequired = 0;
      _this.numberOfSites = 0;
      _this.numberOfSitesRequiringUpdates = 0;
      this.$http({
        url: buildEndpoint('dashboard/get-data'),
      })
        .then((response) => {
          if (response.data.success) {
            const responseData = response.data.data;
            // Set site data
            responseData.sites.forEach((site) => {
              _this.numberOfSites++;
              if (site.updatesRequired > 0) {
                _this.numberOfSitesRequiringUpdates++;
              }
              _this.sites.push(site);
            });
            // _this.sites = _.orderBy(_this.sites, ['updatesRequired', 'Name'], ['desc', 'asc']);
            // Set plugin data
            _this.uniquePluginCount = responseData.pluginSummary.length;
            _this.mostPopularPlugin = responseData.pluginSummary[0];
            _this.pluginSummary = responseData.pluginSummary;
          } else {
            this.error = 'Error getting data';
          }
          this.isLoading = false;
          this.status = false;
          this.error = null;
          if (this.$route.query.refresh === '1') {
            this.scrapeAll();
          }
        })
        .catch(() => {
          this.status = false;
          this.isLoading = false;
          this.error = 'Error getting data';
        });
    },
    scrapeAll() {
      this.error = null;
      this.$http({
        url: buildEndpoint('dashboard/scrape-all-sites'),
      })
        .then((response) => {
          // Nothing to do...we've added all sites to the refresh queue
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
ol {
  margin-left: 30px;
}

.plugin-list {
  thead {
    tr {
      th {
        &:first-child {
          width: 40%;
        }
      }
    }
  }
}
</style>
